
import { useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./WorkTimeManagment.module.css";
import TabBar from "components/tabBar/TabBar";
import { IoMdTime } from "react-icons/io";
import PremanentWorkTime from "./PremanentWorkTime";
import SingelWorkTime from "./singelWorkTime";


export default function WorkTimeManagement() {
    const tabs = [
        { id: "single", label: "Individuelle Öffnungszeiten" },
        { id: "permanent", label: " Allgemeine Öffnungszeiten" },
    ];

    const [activeTab, setActiveTab] = useState<string>(tabs[0].id);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className={styles.container}>
            <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                <IoMdTime className={commonStyles.sectionTitleIcon} />
                <h1>Öffnungszeiten</h1>
            </div>

            <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

            <div className={styles.tabContent}>
                {activeTab === "single" && <SingelWorkTime/>}
                {activeTab === "permanent"&& <PremanentWorkTime />}
            </div>
        </div>
    );
}
